import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { Box, Typography, Paper } from '@mui/material';
import CandidateCard from './CandidateCard';

export default function BoardColumn({ column, candidates }) {
  return (
    <Paper 
      sx={{ 
        width: 600, 
        minWidth: 340,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default', 
        mr: 0,
        maxHeight: '75vh', 
      }}
      elevation={0}
      variant="outlined"
    >
      <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 600, fontSize: '1rem', textTransform: 'capitalize' }}>
          {column.title}
          <Typography component="span" sx={{ ml: 1, color: 'text.secondary' }}>
            ({candidates.length})
          </Typography>
        </Typography>
      </Box>
      <Droppable droppableId={column.id}>
        {(provided, snapshot) => (
          <Box
            ref={provided.innerRef}
            {...provided.droppableProps}
            sx={{
              flexGrow: 1,
              p: 1.5,
              transition: 'background-color 0.2s ease',
              backgroundColor: snapshot.isDraggingOver ? 'action.hover' : 'transparent',
              overflowY: 'auto'
            }}
          >
            {candidates.length > 0 ? (
              candidates.map((candidate, index) => (
                <CandidateCard key={candidate.id} candidate={candidate} index={index} />
              ))
            ) : (
              <Box sx={{ p: 2, textAlign: 'center', color: 'text.disabled' }}>
                <Typography variant="body2">No candidates in this stage.</Typography>
              </Box>
            )}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </Paper>
  );
}

